const defaultValue = {
  crumbs: {
    parent: null,
    chapter: null,
    paragraph: null,
    slug: null,
  },
};
export const useBreadcrumbsStore = defineStore('breadcrumbs', {
  state: () => defaultValue,

  actions: {
    setCrumbs({ key, value }) {
      this.crumbs[key] = value;
    },
    clearCrumbs() {
      this.$patch(defaultValue);
    },
  },

  getters: {
    getCrumbs: (state) => state.crumbs,
  },
});
